import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/base.scss";
// Shared list-page header + filter popover (loaded once so CSS order is stable)
import "./styles/list-header.scss";

import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import store, { persistor } from "./redux/store";

import { LoaderProvider, PageLoader } from "./helpers/contexts/loaderContext";
import { ToastProvider } from "./helpers/contexts/ToastContext";

import AuthLayout from "./layouts/AuthLayout";
import ProtectedRoute from "./routes/ProtectedRoute";
import { authRoutes, protectedRoutes } from "./routes/routes";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <LoaderProvider>
            <ToastProvider>
              <React.Suspense fallback={<PageLoader />}>
                <Routes>
                  {/* Auth routes */}
                  {authRoutes.map(({ path, element }) => (
                    <Route
                      key={path}
                      path={path}
                      element={<AuthLayout>{element}</AuthLayout>}
                    />
                  ))}

                  {/* Protected routes */}
                  {protectedRoutes.map(({ path, element, module, action }) => (
                    <Route
                      key={path}
                      path={path}
                      element={
                        <ProtectedRoute module={module} action={action}>
                          {element}
                        </ProtectedRoute>
                      }
                    />
                  ))}
                  
                  {/* Catch-all route */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </React.Suspense>
            </ToastProvider>
          </LoaderProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
